import { DeviceFamily } from 'shared/models';

//
// Returns true if the given device type supports the
// new device configuration introduced with MatisseR5
//
export function doesDeviceTypeSupportDeviceConfig(deviceType?: { deviceFamily: DeviceFamily | null } | null) {
    const deviceFamily = deviceType?.deviceFamily;
    return (
        deviceFamily === DeviceFamily.Giotto
        || deviceFamily === DeviceFamily.Raffaello
        || deviceFamily === DeviceFamily.MatisseR5
        || deviceFamily === DeviceFamily.MatisseFlexR2
    );
}
